<template>
  <div
    v-show="showWarning"
    class="first-access-modal"
  >
    <div class="warning-content">
      <button @click="$emit('close')">
        <svg-loader src="/static/images/icon-close.svg" />
      </button>

      <h2>
        Gestão de Acesso AOL 2.0
      </h2>
      <br>
      <p>
        Nesta tela, você pode adicionar colaboradores de seu laboratório à plataforma AOL 2.0
        e definir seu tipo de acesso conforme o <strong>Tipo de Perfil</strong>.
        Para cadastrar um novo colaborador, clique em <strong>"Novo Membro"</strong>,
        preencha as informações solicitadas e selecione o perfil de acesso adequado conforme a seguir:
      </p>
      <br>
      <ul>
        <li>
          <strong>Operacional</strong>: Permite cadastrar ordens de serviço, realizar recoletas e remarcações,
          conferir rastreabilidade e imprimir etiquetas. <strong>Não tem acesso a dados financeiros</strong>.
        </li>
        <li>
          <strong>Financeiro</strong>: Permite visualizar guias de exames, boletos, notas fiscais e a lista de preços dos exames.
        </li>
        <li>
          <strong>Administrador</strong>: Acesso completo à plataforma, incluindo cadastro e gerenciamento de usuários,
          <strong>exceto Super Admin</strong>.
        </li>
        <li>
          <strong>Paternidade</strong>: Acesso operacional, incluindo laudos de paternidade, <strong>exceto funções financeiras
            e gerenciamento de usuários</strong>.
        </li>
      </ul>
      <br>
      <p>Após salvar, o membro será listado na tela, onde você poderá editar suas informações ou desativa-lo conforme necessário.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileManagementView',
  props: {
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss">
  .first-access-modal {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .warning-content {
      background-color: #ffffff;
      padding: 36px 48px;
      border-radius: 6px;
      margin-bottom: 24px;
      width: 90%;
      max-width: 1080px;
      color: #363636;
      position: relative;

      button {
        background-color: transparent;
        height: 18px;
        width: 18px;
        position: absolute;
        right: 24px;
        top: 24px;

        .md-icon {
          min-width: 18px;
          min-height: 18px;
          height: 18px;
          width: 18px;

          path {
            fill: #363636;
          }
        }
      }

      strong,
      h2 {
        color: #7f1a54;
      }
    }
  }
</style>
